/* New product card (Amanda, Oct 23, 2026): photo dots + "Choose" sheet with several styles and quantities.
   Uses the card's hidden .variant-select (snippets/product-item.liquid) so main.js still swaps the photo,
   price and Add button when a style is picked, and cart.js refreshes the bag. */
(function () {
  var bg, sheet, state = null;
  function money(cents) { var d = cents / 100; return "$" + (d % 1 ? d.toFixed(2) : d.toFixed(0)); }
  function cents(txt) { var n = parseFloat(String(txt || "").replace(/[^0-9.]/g, "")); return isNaN(n) ? 0 : Math.round(n * 100); }
  /* Card options carry "$20.00"; product page options carry data-money (their data-price is in cents) */
  function optCents(op) { return cents(op.dataset.money || op.dataset.price); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  function pickStyle(card, id) {
    var sel = card.querySelector(".variant-select");
    if (!sel) return;
    sel.value = id;
    sel.dispatchEvent(new Event("change", { bubbles: true }));
    card.querySelectorAll(".bc-dot").forEach(function (d) { d.classList.toggle("on", d.dataset.variant === String(id)); });
  }
  /* Name tag on the card photo after a style dot is tapped, so shoppers see exactly which style "+ Add" puts in the bag
     (Amanda, Oct 26, 2026: "there's no indication of the exact item you're adding"). */
  function nameTag(card, id) {
    var sel = card.querySelector(".variant-select");
    var o = sel && sel.querySelector('option[value="' + id + '"]');
    var box = card.querySelector(".plp-btns .price"); /* above the price, beside "+ Add" (Amanda: not over the photo) */
    var tag = card.querySelector(".bc-picked");
    if (!o || !box) { if (tag) tag.remove(); return; }
    if (!tag) { tag = document.createElement("span"); tag.className = "bc-picked"; tag.setAttribute("aria-live", "polite"); }
    if (tag.parentNode !== box) box.insertBefore(tag, box.firstChild);
    tag.textContent = (o.dataset.title || o.textContent.split(" - ")[0]).trim();
  }

  function build() {
    bg = document.createElement("div"); bg.className = "bc-sheet-bg";
    sheet = document.createElement("div"); sheet.className = "bc-sheet"; sheet.setAttribute("role", "dialog"); sheet.setAttribute("aria-modal", "true"); sheet.setAttribute("aria-label", "Choose a style");
    document.body.appendChild(bg); document.body.appendChild(sheet);
    bg.addEventListener("click", close);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && document.documentElement.classList.contains("bc-open")) close(); });
  }
  function close() { document.documentElement.classList.remove("bc-open"); state = null; }

  /* o (optional, product page): { sel, title, img, onPick } instead of reading them from a product card.
     Oct 26, 2026 (Amanda): the window now starts from what's already in the bag. Styles in the bag show "In bag" with their bag quantity;
     − / + change that quantity, and taking one to zero (or tapping it off) removes it when you tap "Update bag". On collection cards the card
     photo follows the last style picked, like the product page. */
  function open(card, o) {
    if (!sheet) build();
    o = o || {};
    var sel = o.sel || card.querySelector(".variant-select"); if (!sel) return;
    var title = o.title || (card.querySelector(".details .title") || {}).textContent || "";
    var img = o.img || card.querySelector(".swiper-slide img, .hover-gallery img");
    var opts = [].slice.call(sel.options).filter(function (o) { return o.value && !isNaN(Number(o.value)); });
    state = { card: card, opts: opts };
    var onPick = o.onPick || (card && card.classList && card.classList.contains("bc-card") ? function (id) { pickStyle(card, id); card.classList.remove("atc-on"); var t = card.querySelector(".bc-picked"); if (t) t.remove(); /* window picks: the window already shows names */ /* photo follows, but the button stays "Choose" so the window can be reopened */ } : null), lastPick = null;
    var lines = {}; /* variant id -> [{key, quantity}] already in the bag */
    function render() {
      var h = '<div class="grab"></div><div class="top">' + (img ? '<img src="' + esc(img.currentSrc || img.src) + '" alt="">' : "") + '<span class="t">' + esc(title.trim()) + '</span><button type="button" class="x" aria-label="Close"><svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12" stroke="#fff" stroke-width="2.6" stroke-linecap="round"/></svg></button></div>';
      h += '<div class="lbl">Pick styles · use − / + for more than one</div><div class="opts">';
      opts.forEach(function (o, i) {
        var ok = o.dataset.available === "true", bag = bagQ(o.value);
        var on = bag > 0;
        h += '<div class="opt' + (ok || on ? "" : " out") + (on ? " sel inbag" : "") + '" role="button" tabindex="' + (ok || on ? 0 : -1) + '" aria-disabled="' + !(ok || on) + '" data-i="' + i + '" data-q="' + (on ? bag : 1) + '" data-bag="' + bag + '">' +
          (o.dataset.img ? '<img src="' + esc(o.dataset.img) + '" alt="" loading="' + (i < 12 ? "eager" : "lazy") + '">' : "") +
          '<span class="nm">' + esc(o.dataset.title || o.textContent.trim()) + '</span><span class="op">' + (ok || on ? esc(money(optCents(o))) : "Sold out") + '</span>' +
          (ok || on ? '<span class="qty"><button type="button" class="qm" aria-label="One fewer">−</button><b>' + (on ? bag : 1) + '</b><button type="button" class="qp" aria-label="One more">+</button></span>' : "") + '</div>';
      });
      h += '</div><p class="err" hidden></p><button type="button" class="add" disabled>Pick a style</button>';
      sheet.innerHTML = h;
      wire();
    }
    function bagQ(id) { return (lines[id] || []).reduce(function (t, l) { return t + l.quantity; }, 0); }
    function wire() {
      sheet.querySelector(".x").addEventListener("click", close);
      var add = sheet.querySelector(".add");
      function plan() {
        var adds = [], cuts = [], n = 0, total = 0, inBag = 0;
        [].slice.call(sheet.querySelectorAll(".opt:not(.out)")).forEach(function (x) {
          var op = opts[+x.dataset.i], bag = +x.dataset.bag, want = x.classList.contains("sel") ? +x.dataset.q : 0;
          inBag += bag;
          if (want > bag) { adds.push({ id: Number(op.value), quantity: want - bag }); n += want - bag; total += (want - bag) * optCents(op); }
          if (want < bag) cuts.push({ id: op.value, want: want });
        });
        return { adds: adds, cuts: cuts, n: n, total: total, inBag: inBag };
      }
      function sum() {
        var p = plan();
        add.disabled = !p.adds.length && !p.cuts.length;
        if (p.cuts.length) add.textContent = "Update bag";
        else if (p.adds.length) { var one = p.adds.length === 1 && p.n === 1 ? opts.filter(function (o) { return Number(o.value) === p.adds[0].id; })[0] : null;
          add.textContent = (one ? "+ Add " + (one.dataset.title || "").slice(0, 22) : "+ Add " + p.n + " piece" + (p.n > 1 ? "s" : "")) + " · " + money(p.total); }
        else add.textContent = p.inBag ? "In your bag ✓" : "Pick a style";
      }
      function setQ(o, q) { o.dataset.q = q; o.querySelector(".qty b").textContent = q; }
      sheet.querySelectorAll(".opt:not(.out)").forEach(function (o) {
        var max = Math.max(1, parseInt(opts[+o.dataset.i].dataset.max, 10) || 9, +o.dataset.bag);
        o.addEventListener("click", function (e) { if (e.target.closest(".qty")) return; if (o.classList.toggle("sel")) { setQ(o, Math.max(1, +o.dataset.bag || 1)); lastPick = o; if (onPick) onPick(opts[+o.dataset.i].value); } sum(); });
        o.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); o.click(); } });
        o.querySelector(".qp").addEventListener("click", function () { if (!o.classList.contains("sel")) { o.classList.add("sel"); setQ(o, 1); } else setQ(o, Math.min(max, +o.dataset.q + 1)); lastPick = o; if (onPick) onPick(opts[+o.dataset.i].value); sum(); });
        o.querySelector(".qm").addEventListener("click", function () { var q = +o.dataset.q - 1; if (q < 1) { o.classList.remove("sel"); q = 1; } setQ(o, q); sum(); });
      });
      add.addEventListener("click", function () {
        var p = plan(); if (!p.adds.length && !p.cuts.length) return;
        var err = sheet.querySelector(".err"); err.hidden = true; add.disabled = true; add.textContent = p.cuts.length ? "Updating…" : "Adding…";
        /* Read the bag fresh first (it may have changed in the side bag since the window opened), then lower / remove by line key */
        function cutLines(cart) {
          var fresh = {}; (cart.items || []).forEach(function (it) { (fresh[it.variant_id] = fresh[it.variant_id] || []).push({ key: it.key, quantity: it.quantity }); });
          var updates = {};
          p.cuts.forEach(function (c) { var left = c.want; (fresh[c.id] || []).forEach(function (l) { var q = Math.min(l.quantity, left); updates[l.key] = q; left -= q; }); });
          return updates;
        }
        var step1 = !p.cuts.length ? Promise.resolve() : fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
          var updates = cutLines(cart); if (!Object.keys(updates).length) return;
          return fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ updates: updates }) }).then(function (r) { if (!r.ok) throw new Error("update " + r.status); });
        });
        var done = false;
        step1.then(function () {
          if (!p.adds.length) return { ok: true };
          return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" }, body: JSON.stringify({ items: p.adds }) })
            .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); });
        }).then(function (res) {
          if (!res.ok) { err.textContent = (res.d && res.d.description) || "Couldn't add that. Try fewer pieces."; err.hidden = false; sum(); return; }
          done = true;
          add.textContent = p.cuts.length ? "Bag updated ✓" : (p.n > 1 ? p.n + " pieces added" : "Added to bag") + " ✓";
          /* Keep the photo (product page main photo, or the card photo) on the last style picked; never let this show an error */
          try { if (onPick && lastPick && lastPick.classList.contains("sel")) onPick(opts[+lastPick.dataset.i].value); } catch (e) {}
          try { if (typeof getCartContents === "function") getCartContents(); } catch (e) {}
          setTimeout(function () { close(); if (window.bcBagAdded) { window.bcBagAdded(p.cuts.length ? "Bag updated" : ""); return; } /* collection pages: the bag bar, then the circle */ var sc = document.getElementById("side-cart"); if (sc) sc.classList.add("active"); }, 650);
        }).catch(function () { if (done) return; err.textContent = "Couldn't update the bag. Close this and try again."; err.hidden = false; sum(); });
      });
      sum();
    }
    render();
    document.documentElement.classList.add("bc-open");
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
      lines = {};
      (cart.items || []).forEach(function (it) { (lines[it.variant_id] = lines[it.variant_id] || []).push({ key: it.key, quantity: it.quantity }); });
      if (state && state.card === card && Object.keys(lines).some(function (id) { return opts.some(function (o) { return o.value === id; }); })) render();
    }).catch(function () {});
    setTimeout(function () { var f = sheet.querySelector(".opt:not(.out)"); if (f) f.focus({ preventScroll: true }); }, 260);
  }

  /* Capture phase so this runs before the old "Pick one" handlers on cards that have no style picked yet */
  document.addEventListener("click", function (e) {
    var t = e.target;
    var dot = t.closest && t.closest(".bc-card .bc-dot");
    if (dot) { e.preventDefault(); pickStyle(dot.closest(".bc-card"), dot.dataset.variant); nameTag(dot.closest(".bc-card"), dot.dataset.variant); return; }
    var more = t.closest && t.closest(".bc-card .bc-more");
    if (more) { e.preventDefault(); open(more.closest(".bc-card")); return; }
    var btn = t.closest && t.closest(".bc-card.bc-multi .plp-atc-btn");
    if (btn && !btn.closest(".bc-card").classList.contains("atc-on")) { e.preventDefault(); e.stopImmediatePropagation(); open(btn.closest(".bc-card")); }
  }, true);
  /* Product page (Amanda, Oct 26, 2026): "Choose one" opens this same photo window instead of the plain dropdown.
     Also used when Add to Cart is tapped before a style is picked. Needs data-available / data-max on the options (templates/product.liquid). */
  function pdpOpen() {
    var sel = document.querySelector(".product-pg .product-atc .variant-select");
    if (!sel) return false;
    var h1 = document.querySelector(".product-pg .information h1");
    var img = document.querySelector(".product-pg .gallery-container .swiper-slide img, .product-pg .masonry-img");
    /* Each style tapped in the window switches the main photo behind it (main.js slides the gallery on the select's change) */
    var onPick = function (id) { if (sel.value === String(id)) return; sel.value = id; sel.dispatchEvent(new Event("change", { bubbles: true })); };
    open(document.querySelector(".product-pg .information") || document.body, { sel: sel, title: h1 ? h1.textContent : "", img: img, onPick: onPick });
    return true;
  }
  document.addEventListener("click", function (e) {
    var t = e.target;
    var box = t.closest && t.closest(".product-pg .product-atc .select-box.bc-pick");
    var atc = !box && t.closest && t.closest(".product-pg .product-atc .pdp-atc-btn");
    if (!box && !atc) return;
    var sel = document.querySelector(".product-pg .product-atc .variant-select");
    if (!sel || !sel.closest(".select-box.bc-pick")) return;
    if (atc && sel.value && !isNaN(Number(sel.value))) return; /* a style is already set (e.g. from a ?variant= link): normal Add to Cart */
    e.preventDefault(); e.stopImmediatePropagation();
    pdpOpen();
  }, true);
  (function () {
    var sel = document.querySelector(".product-pg .product-atc .variant-select");
    if (!sel || !sel.querySelector("option[data-available]")) return;
    if (/\/products\/gift-card/.test(location.pathname)) return; /* gift card keeps its "Choose an amount" dropdown */
    var box = sel.closest(".select-box"); if (!box) return;
    box.classList.add("bc-pick");
    sel.setAttribute("tabindex", "-1");
    box.setAttribute("role", "button"); box.setAttribute("tabindex", "0"); box.setAttribute("aria-label", "Choose a style");
    box.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); pdpOpen(); } });
  })();

  /* Laptop window shrunk to phone width (Oct 26, 2026): the slideshow was set up while hidden, so it showed 0px tall
     until the page was reloaded. Refresh it once it shows. */
  window.addEventListener("resize", function () {
    var g = document.querySelector(".product-pg main .masonry > .gallery-container");
    if (g && g.swiper && g.offsetWidth > 0 && g.offsetHeight < 50) g.swiper.update();
  });

  /* Back/forward restore: never leave the sheet open */
  window.addEventListener("pageshow", function (e) { if (e.persisted) close(); });
})();

/* Bag (Amanda, Oct 24, 2026): show the product name above the style, and − / + quantity for items with more than one in stock.
   Max per item comes from templates/product.bc-stock.liquid (capped at 9); cart.js re-renders the bag after each change. */
(function () {
  var cache = {};
  function maxFor(handle, vid) {
    if (!cache[handle]) cache[handle] = fetch("/products/" + handle + "?view=bc-stock").then(function (r) { return r.text(); })
      .then(function (t) { try { return JSON.parse(t).variants || {}; } catch (e) { return {}; } }).catch(function () { return {}; });
    return cache[handle].then(function (m) { return m[vid]; });
  }
  function change(key, qty) {
    fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }) })
      .then(function (r) { return r.json(); })
      .then(function () { if (typeof getCartContents === "function") getCartContents(); else location.reload(); });
  }
  function enhance() {
    var loop = document.querySelector("#side-cart .cart-loop");
    if (!loop) return;
    var els = [].slice.call(loop.querySelectorAll(".item[data-key]"));
    if (!els.length) return;
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
      els.forEach(function (el) {
        var it = cart.items.filter(function (i) { return i.key === el.dataset.key; })[0];
        var det = el.querySelector(".details");
        if (!it || !det) return;
        if (!det.querySelector(".bc-ci-title") && !det.querySelector(".title") && it.product_title) {
          var a = document.createElement("a"); a.className = "bc-ci-title"; a.href = it.url; a.textContent = it.product_title;
          det.insertBefore(a, det.firstChild);
        }
        var q = el.querySelector(".bottom-bar .qty");
        if (!q || q.dataset.bc === "1") return;
        q.dataset.bc = "1";
        maxFor(it.handle, it.variant_id).then(function (max) {
          max = max === undefined ? 9 : Number(max);
          if (max <= 1 && it.quantity <= 1) { q.textContent = "Qty 1"; return; }
          q.innerHTML = '<span class="bc-qty"><button type="button" class="bc-qm" aria-label="One fewer">−</button><b>' + it.quantity + '</b><button type="button" class="bc-qp" aria-label="One more"' + (it.quantity >= max ? " disabled" : "") + ">+</button></span>";
          q.querySelector(".bc-qm").addEventListener("click", function () { change(it.key, it.quantity - 1); });
          q.querySelector(".bc-qp").addEventListener("click", function () { if (it.quantity < max) change(it.key, it.quantity + 1); });
        });
      });
    });
  }
  var loop = document.querySelector("#side-cart .cart-loop");
  if (loop) { new MutationObserver(function () { setTimeout(enhance, 30); }).observe(loop, { childList: true }); enhance(); }
})();

/* Laptop card photos (Amanda, Oct 26, 2026: "I don't see the progress bar"): the theme hid the photo strip (and its bar) above 850px
   and only swapped to photo 2 on hover. Cards now show the strip everywhere (bc-card.css); on mouse devices, moving across the photo
   steps through the photos and the bar shows which one. Leaving the photo goes back to where it was. */
(function () {
  if (!window.matchMedia || !matchMedia("(hover:hover) and (pointer:fine)").matches) return;
  function sw(el) { return el && el.swiper; }
  document.addEventListener("mouseover", function (e) {
    var sc = e.target.closest && e.target.closest(".bc-card .swiper-container");
    var s = sw(sc); if (!s || sc.dataset.bcHover) return;
    sc.dataset.bcHover = "1";
    if (!s.slidesGrid || !s.slidesGrid.length || !s.size) s.update();
    var home = s.realIndex;
    function move(ev) {
      var n = s.slides.length; if (n < 2) return; /* loop mode reorders slides, so go by real (photo) index */
      var r = sc.getBoundingClientRect();
      var i = Math.min(n - 1, Math.max(0, Math.floor((ev.clientX - r.left) / r.width * n)));
      if (i !== s.realIndex) s.slideToLoop(i, 0);
    }
    function leave() { sc.removeEventListener("mousemove", move); sc.removeEventListener("mouseleave", leave); delete sc.dataset.bcHover; s.slideToLoop(home, 0); }
    sc.addEventListener("mousemove", move);
    sc.addEventListener("mouseleave", leave);
    move(e);
  });
  /* The strip was hidden when Swiper measured it, so re-measure once it shows */
  function fix() { document.querySelectorAll(".bc-card .swiper-container").forEach(function (sc) { var s = sw(sc); if (s && (!s.slidesGrid || !s.slidesGrid.length)) s.update(); }); }
  if (document.readyState === "complete") fix(); else window.addEventListener("load", fix);
})();

/* Product page photo bar (Amanda, Oct 26, 2026): under the thumbnail strip (phone #bc-thumbs, laptop #bc-rail from snippets/pdp-thumbs.liquid),
   the same segmented bar as the product cards: one gray segment per photo, the current photo in Grape. Replaces the laptop's plain scrollbar. */
(function () {
  function build(strip) {
    if (!strip || strip.dataset.bcBar) return;
    var n = strip.children.length; if (n < 2) return;
    strip.dataset.bcBar = "1";
    var bar = document.createElement("div"); bar.className = "bc-pbar"; bar.setAttribute("aria-hidden", "true");
    for (var i = 0; i < n; i++) bar.appendChild(document.createElement("i"));
    strip.parentNode.insertBefore(bar, strip.nextSibling);
    function sync() { Array.prototype.forEach.call(strip.children, function (b, j) { if (bar.children[j]) bar.children[j].classList.toggle("on", b.getAttribute("aria-current") === "true"); }); }
    new MutationObserver(sync).observe(strip, { subtree: true, attributes: true, attributeFilter: ["aria-current"] });
    sync();
  }
  function init() { build(document.getElementById("bc-thumbs")); build(document.getElementById("bc-rail")); }
  if (!document.querySelector(".product-pg")) return;
  init(); window.addEventListener("load", init); setTimeout(init, 1500); window.addEventListener("resize", function () { setTimeout(init, 300); });
})();

/* Which button really added to the bag (Amanda, Oct 30, 2026). One GA4 event per kind of add, sent only after Shopify accepts it, so + taps that only open the window don't count. */
(function () {
  var from = "", at = 0, realFetch = window.fetch;
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t.closest) return;
    var kind = t.closest(".bc-sheet .add") ? "add_style_window" : t.closest(".nudge-add") ? "add_bag_suggestion" : t.closest(".plp-atc-btn") ? "add_card_plus" : t.closest(".product-atc, .pdp-atc-btn") ? "add_product_page" : "";
    if (kind) { from = kind; at = Date.now(); }
  }, true);
  window.fetch = function (input, init) {
    var url = typeof input === "string" ? input : (input && input.url) || "";
    var kind = /\/cart\/add/.test(url) && from && Date.now() - at < 8000 ? from : "";
    var call = realFetch.apply(this, arguments);
    if (kind) {
      from = "";
      call.then(function (r) {
        if (r.ok && typeof window.gtag === "function") window.gtag("event", kind, { page_type: location.pathname.indexOf("/products/") !== -1 ? "product" : location.pathname.indexOf("/collections/") !== -1 ? "collection" : "other" });
      }).catch(function () {});
    }
    return call;
  };
})();
